// extracted by mini-css-extract-plugin
module.exports = {"container":"_1iVdZVTBiA2eO7A7Xh1gGU","label":"_1S36WVkvnwGzt0TEFI-Hy2","info":"_2xRD7FMg4dHj11Y2fVfjBi"};